<ion-toolbar
  class="header-secondary header-secondary--sm header-secondary--reduced"
  [ngClass]="{'header-secondary--progress': reducedHeight}"
>
  <ion-buttons>
    <ion-progress-bar
      custom-palette
      color="medium-semi-light"
      [value]="value"
    ></ion-progress-bar>
    <ion-label>{{ valuePercent }} {{ 'COMPLETED' | translate }}</ion-label>
  </ion-buttons>
</ion-toolbar>
